import {setMapCenterAction} from "./DataAction"

export const MAP_TOOLTIP_DATA = "MAP_TOOLTIP_DATA";
export const WINDOW_SIZE = "WINDOW_SIZE";
export const HASH_CHANGE = "HASH_CHANGE";
export const SELECTED_ITEM = "SELECTED_ITEM";
export const SET_LEGEND_STATE = "SET_LEGEND_STATE";
export const SET_NAV_STATE = "SET_NAV_STATE";
export const SET_SELECTED_MAP_CONTROL = "SET_SELECTED_MAP_CONTROL";
export const SET_SWITCH_MAP_CONTROL = "SET_SWITCH_MAP_CONTROL";
export const SET_NAV_OPEN = "SET_MENU_OPEN";
export const SET_SETTINGS_OPEN = "SET_SETTINGS_OPEN";
export const SET_STATS_OPEN = "SET_STATS_OPEN";

export const setTooltipDataAction = (data) => dispatch => {
  return dispatch({
    type: MAP_TOOLTIP_DATA,
    payload: {data}
  });
};

export const setWindowSizeAction = dimensions => dispatch => {
  return dispatch({
    type: WINDOW_SIZE,
    payload: dimensions
  });
};

export const setHashAction = hash => dispatch => {
  return dispatch({
    type: HASH_CHANGE,
    payload: hash
  });
};

export const setSelectedItemAction = item => dispatch => {
  return dispatch({
    type: SELECTED_ITEM,
    payload: item
  });
};

export const setLegendStateAction = open => dispatch => {
  return dispatch({
    type: SET_LEGEND_STATE,
    payload: {open}
  });
};

export const setNavStateAction = fixed => dispatch => {
  return dispatch({
    type: SET_NAV_STATE,
    payload: {fixed}
  });
};

export const setSelectMapControlAction = (item, group, clearGroup) => dispatch => {
  setMapCenterAction(item)(dispatch);
  return dispatch({
    type: SET_SELECTED_MAP_CONTROL,
    payload: {item, group, clearGroup}
  });
};

export const setSwitchMapControlAction = (item, group) => dispatch => {
  return dispatch({
    type: SET_SWITCH_MAP_CONTROL,
    payload: {item, group}
  });
};

export const setNavOpenAction = (open) => dispatch => {
  return dispatch({
    type: SET_NAV_OPEN,
    payload: {open}
  });
};

export const setSettingsOpenAction = (open) => dispatch => {
  return dispatch({
    type: SET_SETTINGS_OPEN,
    payload: {open}
  });
};

export const setStatsStateAction = open => dispatch => {
  return dispatch({
    type: SET_STATS_OPEN,
    payload: {open}
  });
};


